import { Seo } from "../components/Seo";
import { Reveal, Eyebrow } from "../components/Reveal";
import CtaBand from "../components/sections/CtaBand";
import WhyUs from "../components/sections/WhyUs";
import { IMAGES } from "../lib/data";

const About = () => (
  <main data-testid="about-page">
    <Seo
      title="About Petroline Services | Commercial Contractor for Petroleum Retail Ontario"
      description="Petroline Services is a Milton-based commercial contractor focused on the repair, maintenance, renovation and improvement needs of petroleum retail facilities across Southern Ontario."
    />

    <section className="mx-auto max-w-7xl px-5 pb-20 pt-24 lg:px-8 lg:pt-32">
      <Reveal>
        <Eyebrow>About Petroline Services</Eyebrow>
        <h1 className="max-w-3xl font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
          Commercial Service. <span className="text-ember">Petroleum Retail Focus.</span>
        </h1>
      </Reveal>
    </section>

    <section className="border-t border-black/10 bg-ink-surface">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 py-20 lg:grid-cols-2 lg:gap-20 lg:px-8 lg:py-28">
        <Reveal className="relative">
          <div className="absolute -left-4 -top-4 h-full w-full border border-ember/40" aria-hidden="true" />
          <img
            src={IMAGES.construction.url}
            alt={IMAGES.construction.alt}
            loading="lazy"
            className="relative aspect-[4/3] w-full object-cover"
          />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl">
            A dependable contractor for the properties that never close.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-mist md:text-lg">
            Petroline Services was established to give petroleum retail operators a dependable
            commercial contractor — one capable of supporting the ongoing repair, maintenance,
            renovation and improvement needs of their facilities.
          </p>
          <p className="mt-4 text-base leading-relaxed text-mist md:text-lg">
            We are not a fuel supplier or an oil company. We are the commercial service partner
            behind the property: the forecourt, the building, the car wash, the systems and the
            details customers notice every day.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="border-t border-black/10">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28">
        <Reveal>
          <Eyebrow>How We Work</Eyebrow>
          <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
            What you can expect on every job.
          </h2>
        </Reveal>
        <div className="mt-12 grid gap-px border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-3">
          {[
            { title: "Reliability", text: "We show up, communicate clearly and follow through on the work we commit to." },
            { title: "Responsiveness", text: "Maintenance issues are time-sensitive. We prioritize prompt, practical responses." },
            { title: "Practical Solutions", text: "Straightforward recommendations focused on what your facility actually needs." },
            { title: "Commercial Workmanship", text: "Clean, organized execution suited to operating commercial environments." },
            { title: "Long-Term Facility Care", text: "A preventive mindset that protects the condition and value of your property." },
            { title: "Clear Communication", text: "You always know what is happening, what it involves and what comes next." },
          ].map((value, i) => (
            <Reveal key={value.title} delay={(i % 3) * 0.08} className="h-full">
              <div
                data-testid={`value-card-${value.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="h-full bg-white p-8"
              >
                <h3 className="font-display text-lg font-bold tracking-tight text-ember">{value.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-mist">{value.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <WhyUs />
    <CtaBand title="Discuss your project with Petroline Services." />
  </main>
);

export default About;
